import ColumnGroupsParser from 'src/helpers/modular/detailedSummaryReport/parser/columnGroupsParser';
import RowsParser from 'src/helpers/modular/detailedSummaryReport/parser/rowsParser';
class DetailedSummaryReportParser {
    static parse({ rawReport, mainReportConfirmations }) {
        const { Departments, DepartmentsSums } = rawReport;
        if (!Departments || !DepartmentsSums) {
            return {};
        }
        return {
            columnGroups: ColumnGroupsParser.parse(rawReport),
            rows: RowsParser.parse(Departments, mainReportConfirmations),
            totals: RowsParser.getRowData(DepartmentsSums)
        };
    }
}
export default DetailedSummaryReportParser;
